'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, About);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = About.__proto__ || (0, _getPrototypeOf2.default)(About)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showKitten: false
    }, _this.handleToggleKitten = function () {
      return _this.setState({ showKitten: !_this.state.showKitten });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var showKitten = this.state.showKitten;

      var kitten = require('./kitten.jpg');
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'About Us'
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'About Us' }),
        _react2.default.createElement(
          'p',
          null,
          'This project was originally created by Erik Rasmussen (',
          _react2.default.createElement(
            'a',
            { href: 'https://twitter.com/erikras', target: '_blank' },
            '@erikras'
          ),
          '), but has since seen many contributions from the open source community. Thank you to ',
          _react2.default.createElement(
            'a',
            {
              href: 'https://github.com/erikras/react-redux-universal-hot-example/graphs/contributors',
              target: '_blank' },
            'all the contributors'
          ),
          '.'
        ),
        _react2.default.createElement(
          'h3',
          null,
          'Mini Bar ',
          _react2.default.createElement(
            'span',
            { style: { color: '#aaa' } },
            '(not that kind)'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Hey! You found the mini info bar! The following component is display-only. Note that it shows the same time as the info bar.'
        ),
        _react2.default.createElement(_components.MiniInfoBar, null),
        _react2.default.createElement(
          'h3',
          null,
          'Images'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Psst! Would you like to see a kitten?',
          _react2.default.createElement(
            'button',
            { className: 'btn btn-' + (showKitten ? 'danger' : 'success'),
              style: { marginLeft: 50 },
              onClick: this.handleToggleKitten },
            showKitten ? 'No! Take it away!' : 'Yes! Please!'
          )
        ),
        showKitten && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: kitten })
        )
      );
    }
  }]);
  return About;
}(_react.Component);

exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1513
// module chunks = 0